import React, { useContext, useEffect, useState, useRef } from "react";
import {
    getRawMaterials,
    deleteRawMaterials,
    updateRawMaterials,
    createRawMaterials,
    getUnits,
    getRawMaterialBatches,
    adjustRawMaterialStock,
    get_rawtransaction,
    revert_added_stock,
    transfer_packaging_material_quantity
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate, getStoredEntriesPerPage, setStoredEntriesPerPage, getFormattedCurrentDate2 } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation, useNavigate } from "react-router-dom"
import { EditRawMaterials } from "./rform";
import Select from "react-select";
import moment from "moment";

const FormattedDateInput = ({ name, value, onChange, min, max, className, disabled, required }) => {
    const inputRef = useRef(null);

    const handleClick = () => {
        if (disabled) return;
        try {
            if (inputRef.current && typeof inputRef.current.showPicker === 'function') {
                inputRef.current.showPicker();
            }
        } catch (err) {}
    };

    return (
        <div
            className="position-relative w-100"
            style={{ pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.7 : 1 }}
            onClick={handleClick}
        >
            <style>{`
                .custom-full-date-picker-pkg::-webkit-calendar-picker-indicator {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                    cursor: pointer;
                }
            `}</style>
            <input
                ref={inputRef}
                type="date"
                name={name}
                className="custom-full-date-picker-pkg"
                value={value || ''}
                min={min}
                max={max}
                onChange={onChange}
                disabled={disabled}
                required={required}
                onClick={(e) => {
                    try {
                        if (typeof e.target.showPicker === 'function') {
                            e.target.showPicker();
                        }
                    } catch (err) {}
                }}
                style={{
                    opacity: 0,
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    zIndex: 10
                }}
            />
            <div className={`form-control d-flex align-items-center justify-content-between ${className || ''}`} style={{ cursor: disabled ? 'not-allowed' : 'pointer', minHeight: '38px' }}>
                <span className={value ? "text-dark font-medium" : "text-muted"}>
                    {value ? (moment(value).isValid() ? moment(value).format('DD/MM/YYYY') : value) : 'DD/MM/YYYY'}
                </span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-secondary">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
            </div>
        </div>
    );
};

const selectStyles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: "38px",
        height: "38px",
        fontSize: "14px",
        borderRadius: "0.375rem",
        borderColor: state.isFocused ? "#0284c7" : "#cbd5e1",
        boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(2, 132, 199, 0.25)" : "none",
        fontFamily: "Poppins, sans-serif",
        "&:hover": {
            borderColor: state.isFocused ? "#0284c7" : "#94a3b8"
        }
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 })
};

const RawMaterials = () => {
    const { showLoader, hideLoader, shopItem, warehouse, UserItem } = useContext(WarehouseContext);
    const { pathname, search } = useLocation();
    const navigate = useNavigate();
    const readonly = isReadonlyRoute(pathname);

    const isPkgRoute = pathname === "/packaging_materials" || search.includes("type=1") || search.includes("tab=pkg") || search.includes("pkg");
    const currentStorageKey = isPkgRoute ? "packaging_materials" : "raw_materials";

    const [rawmaterials, setRawmaterials] = useState([]);
    const [selectedRaw, setSelectedRaw] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [addOrEdit, setAddOrEdit] = useState(true);
    const [activeTab, setActiveTab] = useState(isPkgRoute ? "1" : "raw");

    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(() => getStoredEntriesPerPage(currentStorageKey, 10));
    const rolesPerPage = 10;
    const [unitsList, setUnitsList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const isMounted = useRef(false);

    const [showAdjustModal, setShowAdjustModal] = useState(false);
    const [adjustRawMaterial, setAdjustRawMaterial] = useState(null);
    const [adjustFormData, setAdjustFormData] = useState({
        date: new Date().toISOString().split("T")[0],
        adjustment_type: "add",
        qty: "",
        unit_id: "",
        price_unit: "",
        total_price: "",
        remarks: "",
    });

    // Report Modal State
    const [showReportModal, setShowReportModal] = useState(false);
    const [reportRawMaterial, setReportRawMaterial] = useState(null);
    const [allReportTransactions, setAllReportTransactions] = useState([]);
    const [reportFilter, setReportFilter] = useState(""); // "" = All, "1" = Added, "0" = Taken
    const [reportLoading, setReportLoading] = useState(false);
    const reportPrintRef = useRef(null);

    // Transfer Modal State for Packaging Materials
    const [showTransferModal, setShowTransferModal] = useState(false);
    const [transferSource, setTransferSource] = useState(null);
    const [transferTarget, setTransferTarget] = useState(null);
    const [transferQty, setTransferQty] = useState("");
    const [transferType, setTransferType] = useState("partial"); // "partial" or "full"
    const [transferDate, setTransferDate] = useState(getFormattedCurrentDate2());
    const [transferRemarks, setTransferRemarks] = useState("");
    const [isTransferring, setIsTransferring] = useState(false);
    const [transferTargetOptions, setTransferTargetOptions] = useState([]);
    const [transferError, setTransferError] = useState("");

    const openReportModal = async (raw) => {
        setReportRawMaterial(raw);
        setReportFilter("");
        setShowReportModal(true);
        fetchReportTransactions(raw.id);
    };

    const fetchReportTransactions = async (raw_id) => {
        setReportLoading(true);
        try {
            const response = await get_rawtransaction(1, 10000, "", "", "", raw_id);
            if (response.data && response.data.data) {
                setAllReportTransactions(response.data.data);
            } else {
                setAllReportTransactions([]);
            }
        } catch (error) {
            console.error("Error fetching report transactions:", error);
            toast.error("Failed to load transaction report");
        } finally {
            setReportLoading(false);
        }
    };

    const [revertConfirmItem, setRevertConfirmItem] = useState(null);
    const [revertLoading, setRevertLoading] = useState(false);

    const handleConfirmRevert = async () => {
        if (!revertConfirmItem) return;
        setRevertLoading(true);
        try {
            const response = await revert_added_stock({
                transaction_id: revertConfirmItem.id,
                stock_type: "raw",
                user_id: UserItem?.user_id || UserItem?.id
            });
            if (response.data && response.data.status === "success") {
                toast.success(response.data.message || "Stock addition reverted successfully");
                setRevertConfirmItem(null);
                if (reportRawMaterial?.id) {
                    fetchReportTransactions(reportRawMaterial.id);
                }
                fetchRawmaterials(currentPage, searchText, activeTab);
                // Also update remaining stock in report view
                try {
                    const rawRes = await getRawMaterials(1, 1000, "", activeTab, entriesPerPage);
                    if (rawRes.data && rawRes.data.data) {
                        const updatedItem = rawRes.data.data.find(r => r.id === reportRawMaterial?.id);
                        if (updatedItem) {
                            setReportRawMaterial(updatedItem);
                        }
                    }
                } catch (e) {
                    console.error("Error refreshing raw material remaining stock:", e);
                }
            } else {
                toast.error(response.data?.message || "Failed to revert stock");
            }
        } catch (error) {
            console.error("Error reverting stock:", error);
            toast.error(error.response?.data?.message || "Error reverting stock");
        } finally {
            setRevertLoading(false);
        }
    };

    const getUnitName = (unitId) => {
        if (!unitId) return "";
        const found = unitsList.find(u => String(u.id) === String(unitId));
        if (found) return found.title;
        if (String(unitId) === "1") return "kg";
        if (String(unitId) === "2") return "gram";
        if (String(unitId).toLowerCase() === "li") return "li";
        return unitId;
    };

    const convertTxQtyToBaseUnit = (tx, rawMat = reportRawMaterial) => {
        const rawQty = parseFloat(tx?.qty || 0);
        if (!rawQty || isNaN(rawQty)) return 0;

        const baseUnit = (rawMat?.type == "2" ? "li" : getUnitName(rawMat?.unit_id) || "kg").toLowerCase().trim();
        const txUnit = (getUnitName(tx?.unit_id) || tx?.unit_id || baseUnit).toString().toLowerCase().trim();

        if (txUnit === baseUnit) {
            return rawQty;
        }

        const pcsPerKg = parseFloat(rawMat?.pcs_per_kg || 0);

        // If Base is KG and Tx is Grams
        if ((baseUnit === "kg" || baseUnit === "kilogram" || baseUnit === "1") && (txUnit === "gram" || txUnit === "grams" || txUnit === "g" || txUnit === "2")) {
            return rawQty / 1000;
        }

        // If Base is Grams and Tx is KG
        if ((baseUnit === "gram" || baseUnit === "grams" || baseUnit === "g" || baseUnit === "2") && (txUnit === "kg" || txUnit === "kilogram" || txUnit === "1")) {
            return rawQty * 1000;
        }

        // If Base is KG and Tx is Pieces (pcs)
        if ((baseUnit === "kg" || baseUnit === "kilogram" || baseUnit === "1") && (txUnit === "pcs" || txUnit === "piece" || txUnit === "pieces" || txUnit === "pkt")) {
            if (pcsPerKg > 0) {
                return rawQty / pcsPerKg;
            }
            const priceUnit = parseFloat(tx?.price_unit || 0);
            const basePrice = parseFloat(rawMat?.price_unit || rawMat?.latest_price_unit || rawMat?.cost_price || 0);
            if (priceUnit > 0 && basePrice > 0) {
                const calculatedPcsPerKg = basePrice / priceUnit;
                if (calculatedPcsPerKg > 0) {
                    return rawQty / calculatedPcsPerKg;
                }
            }
        }

        // If Base is Pieces and Tx is KG
        if ((baseUnit === "pcs" || baseUnit === "piece" || baseUnit === "pieces") && (txUnit === "kg" || txUnit === "kilogram" || txUnit === "1")) {
            if (pcsPerKg > 0) {
                return rawQty * pcsPerKg;
            }
        }

        return rawQty;
    };

    const handlePrintReport = () => {
        const printContent = reportPrintRef.current;
        if (!printContent) return;

        const totalAdded = allReportTransactions
            .filter(t => String(t.add_taken) === "1")
            .reduce((acc, t) => acc + convertTxQtyToBaseUnit(t), 0);

        const totalTaken = allReportTransactions
            .filter(t => String(t.add_taken) === "0")
            .reduce((acc, t) => acc + convertTxQtyToBaseUnit(t), 0);

        const unitStr = reportRawMaterial?.type == "2" ? "li" : (getUnitName(reportRawMaterial?.unit_id) || "kg");
        const availableStock = parseFloat(reportRawMaterial?.remaining_stock || 0);

        const printWindow = window.open("", "", "width=900,height=650");
        printWindow.document.write(`
            <html>
                <head>
                    <title>Raw Material Date-Wise Report - ${reportRawMaterial?.title || ""}</title>
                    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
                    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css">
                    <style>
                        body { font-family: 'Poppins', sans-serif; padding: 25px; color: #222; }
                        .table { font-size: 12px; border-color: #dee2e6; }
                        .badge { font-size: 11px; }
                        h4 { font-weight: 700; color: #111; }
                        .print-header { border-bottom: 2px solid #0d6efd; padding-bottom: 12px; margin-bottom: 16px; }
                        .summary-box {
                            border-radius: 6px;
                            padding: 10px 14px;
                            text-align: center;
                        }
                        .no-print { display: none !important; }
                        @media print {
                            body { padding: 12px; }
                            .no-print { display: none !important; }
                            * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-header d-flex justify-content-between align-items-center">
                        <div>
                            <h4 class="m-0">ZTR ERP - Raw Material Date-Wise Report</h4>
                            <p class="text-muted m-0" style="font-size: 13px;">
                                Material: <strong>${reportRawMaterial?.title || ""}</strong> | Code: ${reportRawMaterial?.product_code || "N/A"} | Type: ${reportRawMaterial?.type == "2" ? "Liquid" : reportRawMaterial?.type == "1" ? "Packaging Material" : "Spices"}
                            </p>
                        </div>
                        <div class="text-end">
                            <div class="text-muted" style="font-size: 11px;">Generated on: ${new Date().toLocaleString("en-GB")}</div>
                            ${reportFilter === "1" ? '<span class="badge bg-success mt-1">Showing: Stock Added (In)</span>' : reportFilter === "0" ? '<span class="badge bg-danger mt-1">Showing: Stock Taken (Out)</span>' : '<span class="badge bg-secondary mt-1">Showing: All Transactions</span>'}
                        </div>
                    </div>

                    <!-- Summary Cards in Print -->
                    <div class="row g-3 mb-3">
                        <div class="col-4">
                            <div class="summary-box" style="border: 1px solid #198754; background-color: #f0fdf4 !important;">
                                <div style="font-size: 10px; font-weight: 700; color: #166534; text-transform: uppercase; letter-spacing: 0.5px;">Total Stock Added</div>
                                <div style="font-size: 17px; font-weight: 700; color: #15803d; margin-top: 2px;">
                                    + ${totalAdded.toFixed(3)} <span style="font-size: 12px; font-weight: 500;">${unitStr}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="summary-box" style="border: 1px solid #dc3545; background-color: #fef2f2 !important;">
                                <div style="font-size: 10px; font-weight: 700; color: #991b1b; text-transform: uppercase; letter-spacing: 0.5px;">Total Stock Taken</div>
                                <div style="font-size: 16px; font-weight: 700; color: #b91c1c; margin-top: 2px;">
                                    - ${totalTaken.toFixed(3)} <span style="font-size: 12px; font-weight: 500;">${unitStr}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="summary-box" style="border: 1px solid #0d6efd; background-color: #eff6ff !important;">
                                <div style="font-size: 10px; font-weight: 700; color: #1e40af; text-transform: uppercase; letter-spacing: 0.5px;">Current Available Stock</div>
                                <div style="font-size: 17px; font-weight: 700; color: #1d4ed8; margin-top: 2px;">
                                    ${availableStock.toFixed(3)} <span style="font-size: 12px; font-weight: 500;">${unitStr}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    ${printContent.innerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 400);
    };

    const openAdjustModal = async (raw) => {
        setAdjustRawMaterial(raw);
        
        // Find default unit based on raw material type
        let defaultUnit = "";
        if (raw.type === "2") {
            const found = unitsList.find(u => {
                const title = (u.title || "").toLowerCase();
                return title === "li" || title === "litre" || title === "litres" || title === "liter" || title === "liters";
            });
            defaultUnit = found ? found.id : "li";
        } else if (raw.type === "1") {
            const found = unitsList.find(u => u.title?.toLowerCase() === "pcs");
            defaultUnit = found ? found.id : "pcs";
        } else {
            defaultUnit = raw.unit_id || "";
            if (!defaultUnit) {
                const found = unitsList.find(u => {
                    const title = (u.title || "").toLowerCase();
                    return title === "kg" || title === "kilogram" || title === "kilograms";
                });
                defaultUnit = found ? found.id : "1";
            }
        }

        let defaultPrice = "0.00";
        showLoader();
        try {
            const response = await getRawMaterialBatches(raw.id, shopItem?.id);
            if (response.data && response.data.data && response.data.data.length > 0) {
                const latestBatch = response.data.data[0];
                if (latestBatch && latestBatch.price_unit) {
                    defaultPrice = parseFloat(latestBatch.price_unit).toFixed(2);
                }
            }
        } catch (error) {
            console.error("Error fetching latest batch price:", error);
        } finally {
            hideLoader();
        }

        setAdjustFormData({
            date: new Date().toISOString().split("T")[0],
            adjustment_type: "add",
            qty: "",
            unit_id: defaultUnit,
            price_unit: defaultPrice,
            total_price: "0.00",
            remarks: "",
        });
        setShowAdjustModal(true);
    };

    const handleAdjustFormChange = (field, value) => {
        setAdjustFormData((prev) => {
            const updated = { ...prev, [field]: value };
            if (field === "qty" || field === "price_unit") {
                const q = parseFloat(field === "qty" ? value : updated.qty) || 0;
                const p = parseFloat(field === "price_unit" ? value : updated.price_unit) || 0;
                updated.total_price = (q * p).toFixed(2);
            } else if (field === "total_price") {
                const t = parseFloat(value) || 0;
                const q = parseFloat(updated.qty) || 0;
                if (q > 0) {
                    updated.price_unit = (t / q).toFixed(2);
                }
            }
            return updated;
        });
    };

    const handleAdjustSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const qtyNum = parseFloat(adjustFormData.qty);
        if (!qtyNum || isNaN(qtyNum) || qtyNum <= 0) {
            toast.error("Please enter a valid quantity greater than 0");
            return;
        }
        if (!adjustFormData.date) {
            toast.error("Please select a date for the adjustment");
            return;
        }

        const currentStock = parseFloat(adjustRawMaterial?.remaining_stock || 0);
        if (adjustFormData.adjustment_type === "deduct" && qtyNum > currentStock) {
            toast.error(`Cannot deduct ${qtyNum}. Only ${currentStock.toFixed(3)} available in stock.`);
            return;
        }

        showLoader();
        try {
            const payload = {
                raw_mat_id: adjustRawMaterial?.id,
                adjustment_type: adjustFormData.adjustment_type,
                date: adjustFormData.date,
                qty: qtyNum,
                unit_id: adjustFormData.unit_id || "",
                price_unit: parseFloat(adjustFormData.price_unit || 0),
                total_price: parseFloat(adjustFormData.total_price || 0),
                remarks: adjustFormData.remarks || `Stock Adjustment (${adjustFormData.adjustment_type === "add" ? "Add Batch" : "Deduct"}) - ${adjustRawMaterial?.title}`,
                shop_id: shopItem?.id,
                user_id: UserItem?.user_id || "0",
            };
            const response = await adjustRawMaterialStock(payload);
            if (response.data && response.data.status === "success") {
                toast.success(response.data.message || "Stock adjusted successfully");
                setShowAdjustModal(false);
                setAdjustRawMaterial(null);
                fetchRawmaterials(currentPage, searchText, activeTab);
            } else {
                toast.error(response.data.message || "Failed to adjust stock");
            }
        } catch (error) {
            console.error("Error adjusting stock:", error);
            toast.error(error.response?.data?.message || "Failed to adjust stock");
        } finally {
            hideLoader();
        }
    };

    const handleOpenTransferModal = async (raw) => {
        const avl = parseFloat(raw.remaining_stock || 0);
        if (avl <= 0) {
            toast.warning("This packaging material has no available stock to transfer.");
            return;
        }

        setTransferSource(raw);
        setTransferTarget(null);
        setTransferType("partial");
        setTransferQty("");
        setTransferDate(getFormattedCurrentDate2());
        setTransferRemarks(`Transferred from ${raw.title}`);
        setTransferError("");
        setShowTransferModal(true);

        try {
            showLoader();
            const response = await getRawMaterials({
                shop_id: shopItem?.id,
                type: "1", // Packaging material
                limit: 1000,
                page_size: 1000
            });

            if (response.data && response.data.data) {
                const sourceNorm = normalizeUnit(raw.unit_id) || "kg";
                const sourceUnitDisplay = getUnitName(raw.unit_id) || "KG";

                const options = response.data.data
                    .filter(item => {
                        // 1. Cannot transfer to itself
                        if (String(item.id) === String(raw.id)) return false;

                        const itemNorm = normalizeUnit(item.unit_id);

                        // 2. If target material has an established unit, it MUST match the source unit
                        // (DO NOT list materials with other units, e.g. KGs cannot be transferred to Pieces)
                        if (itemNorm) {
                            return itemNorm === sourceNorm;
                        }

                        // 3. If target material has NO established unit yet (e.g. 0 qty item without transactions like 200 CHIKEN 65):
                        // List it as an eligible target so stock can be transferred into it
                        return true;
                    })
                    .map(item => {
                        const itemStock = parseFloat(item.remaining_stock || 0);
                        const itemUnitTitle = getUnitName(item.unit_id) || sourceUnitDisplay;
                        return {
                            value: item.id,
                            label: `${item.title} (Stock: ${itemStock.toFixed(3)} ${itemUnitTitle})`,
                            item: {
                                ...item,
                                unit_id: item.unit_id || raw.unit_id
                            }
                        };
                    })
                    .sort((a, b) => (a.item?.title || "").localeCompare(b.item?.title || "", undefined, { sensitivity: 'base' }));

                setTransferTargetOptions(options);
            }
        } catch (err) {
            console.error("Error loading target packaging materials:", err);
        } finally {
            hideLoader();
        }
    };

    const handlePresetPercent = (pct) => {
        if (!transferSource) return;
        const avl = parseFloat(transferSource.remaining_stock || 0);
        if (avl <= 0) return;
        const val = (avl * (pct / 100)).toFixed(3);
        setTransferQty(val);
        if (pct === 100) {
            setTransferType("full");
        } else {
            setTransferType("partial");
        }
    };

    const handleConfirmTransfer = async () => {
        if (!transferSource) return;
        if (!transferTarget) {
            toast.error("Please select a target packaging material.");
            setTransferError("Please select a target packaging material.");
            return;
        }

        const avl = parseFloat(transferSource.remaining_stock || 0);
        const qty = parseFloat(transferQty || 0);

        if (!qty || isNaN(qty) || qty <= 0) {
            toast.error("Please enter a valid transfer quantity greater than 0.");
            setTransferError("Please enter a valid transfer quantity greater than 0.");
            return;
        }

        if (qty > avl) {
            toast.error(`Transfer quantity exceeds available stock (${avl.toFixed(3)}).`);
            setTransferError(`Transfer quantity exceeds available stock (${avl.toFixed(3)}).`);
            return;
        }

        const todayStr = getFormattedCurrentDate2();
        if (transferDate && transferDate > todayStr) {
            toast.error("Transfer date cannot be in the future (after today).");
            setTransferError("Transfer date cannot be in the future (after today).");
            return;
        }

        setIsTransferring(true);
        setTransferError("");
        showLoader();

        try {
            const payload = {
                source_raw_mat_id: transferSource.id,
                target_raw_mat_id: transferTarget.value,
                transfer_qty: qty,
                transfer_date: transferDate || todayStr,
                remarks: transferRemarks,
                shop_id: shopItem?.id,
                user_id: UserItem?.user_id || "1",
                unit_id: transferSource.unit_id || ""
            };

            const response = await transfer_packaging_material_quantity(payload);
            if (response.data && response.data.status === "success") {
                toast.success(response.data.message || "Quantity transferred successfully!");
                setShowTransferModal(false);
                setTransferSource(null);
                setTransferTarget(null);
                fetchRawmaterials(currentPage, searchText, activeTab);
            } else {
                const msg = response.data?.message || "Failed to transfer packaging material quantity.";
                toast.error(msg);
                setTransferError(msg);
            }
        } catch (err) {
            console.error("Error transferring packaging material:", err);
            const msg = err.response?.data?.message || err.message || "Failed to transfer quantity.";
            toast.error(msg);
            setTransferError(msg);
        } finally {
            setIsTransferring(false);
            hideLoader();
        }
    };

    useEffect(() => {
        const isPkg = pathname === "/packaging_materials" || search.includes("type=1") || search.includes("tab=pkg") || search.includes("pkg");
        const targetTab = isPkg ? "1" : "raw";
        const targetKey = isPkg ? "packaging_materials" : "raw_materials";
        const targetLimit = getStoredEntriesPerPage(targetKey, 10);
        setActiveTab(targetTab);
        setCurrentPage(1);
        setEntriesPerPage(targetLimit);
        fetchRawmaterials(1, "", targetTab, targetLimit);
        fetchUnitsList();
    }, [pathname, search]);

    const fetchUnitsList = async () => {
        try {
            const response = await getUnits();
            if (response.data && response.data.data) {
                setUnitsList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching units:", error);
        }
    };


    const normalizeUnit = (unitId) => {
        if (!unitId && unitId !== 0) return "";
        const rawStr = String(unitId).trim().toLowerCase();
        if (!rawStr) return "";
        const found = unitsList.find(u => String(u.id).toLowerCase() === rawStr || String(u.title).toLowerCase() === rawStr);
        const title = (found ? found.title : rawStr).toLowerCase().trim();

        if (title === "kg" || title === "kilogram" || title === "kilograms" || title === "1") return "kg";
        if (title === "gram" || title === "grams" || title === "gm" || title === "g" || title === "2") return "gram";
        if (title === "pcs" || title === "pieces" || title === "piece" || title === "pc") return "pcs";
        if (title === "li" || title === "litre" || title === "litres" || title === "liter" || title === "liters") return "li";
        return title;
    };

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);
    };

    const fetchRawmaterials = async (page = 1, text = searchText, tab = activeTab, limit = entriesPerPage) => {
        showLoader();
        try {
            const response = await getRawMaterials({
                shop_id: shopItem?.id,
                page,
                search: text,
                type: tab,
                limit: limit,
                page_size: limit
            });
            if (response.data && response.data.data) {
                const sortedData = [...response.data.data].sort((a, b) =>
                    (a.title || "").localeCompare(b.title || "", undefined, { sensitivity: 'base' })
                );
                setRawmaterials(sortedData);
                setTotalPages(response.data.pagination?.total_pages || 1);
            }
        } catch (error) {
            console.error("Error fetching raw materials:", error);
            toast.error("Failed to fetch raw materials");
        } finally {
            hideLoader();
        }
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setCurrentPage(1);
        fetchRawmaterials(1, searchText, tab, entriesPerPage);
    };

    const openAddModal = () => {
        setAddOrEdit(true);
        setSelectedRaw(null);
        console.log('clicked')
        setShowEditModal(true);
    };

    const openEditModal = (raw) => {
        setSelectedRaw(raw);
        setAddOrEdit(false);
        console.log('clicked  222')

        setShowEditModal(true);
    };

    const handleDelete = async () => {
        if (!deleteID) {
            toast.error("No raw material selected to delete");
            return;
        }

        try {
            await deleteRawMaterials(deleteID);
            showDeletemodel(false);
            toast.success("Raw material deleted");
            fetchRawmaterials(currentPage, searchText, activeTab);
        } catch (error) {
            console.error("Error deleting raw material:", error);
            toast.error("Error deleting raw material");
        }
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        fetchRawmaterials(pageNumber, searchText, activeTab, entriesPerPage);
    };

    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }

        const delayDebounceFn = setTimeout(() => {
            setSearchText(searchInput);
            fetchRawmaterials(1, searchInput, activeTab, entriesPerPage);
            setCurrentPage(1);
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [searchInput]);

    const activateRawMaterial = async (value) => {
        showLoader();
        try {
            const payload = {
                ...value,
                status: "active",
            };
            await updateRawMaterials(value?.id, payload);
            fetchRawmaterials(currentPage, searchText, activeTab);
            toast.success("Raw material activated");
        } catch (err) {
            console.error(err);
            toast.error(err.message);
        } finally {
            hideLoader();
        }
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6
                        className="mb-0 text-uppercase"
                        style={{ fontFamily: "poppins" }}
                    >
                        {activeTab === "1" ? "Packaging Materials List" : "Raw Materials List"}
                    </h6>
                    {!readonly && (
                        <div className="d-flex gap-2">
                            <button
                                type="button"
                                onClick={() => navigate("/purchase")}
                                className="btn btn-success mb-0"
                                style={{ fontFamily: "poppins" }}
                            >
                                RM Purchase
                            </button>
                            <button
                                type="button"
                                onClick={() => openAddModal()}
                                className="btn btn-primary mb-0"
                                style={{ fontFamily: "poppins" }}
                            >
                                {activeTab === "1" ? "Add Packaging Material" : "Add Raw Material"}
                            </button>
                        </div>
                    )}
                </div>
                <hr className="mt-1" />

                <div className="card">
                    <div className="card-body">
                        {/* Tabs removed as menu is now separate in sidebar */}

                        <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                            <div
                                className="d-flex position-relative"
                                style={{ width: "100%" }}
                            >
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search..."
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                />
                                <img
                                    src="/assets/images/icons/search.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        height: "18px",
                                        pointerEvents: "none",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                className="table table-striped table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Title</th>
                                        <th>Type</th>
                                        <th>Product Code</th>
                                        <th>Reorder Point</th>
                                        <th>Stocks Available</th>
                                        {/* <th>Status</th> */}
                                        {/* <th>Created By</th> */}
                                        {!readonly && <th>Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rawmaterials.map((raw, index) => (
                                        <tr key={raw.id}>
                                            <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                                            <td>{raw.title}</td>
                                            <td>{raw.type == "1" ? "Packaging material" : raw.type == "2" ? "Liquid" : "Spices"}</td>
                                            <td>{raw.product_code}</td>
                                            <td>{raw.reorder_point}</td>
                                            <td>{parseFloat(raw.remaining_stock || 0).toFixed(3)} {raw.type == "2" ? "li" : getUnitName(raw.unit_id)}</td>
                                            {/* <td>{raw.status}</td> */}
                                            {/* <td>{raw.created_by}</td> */}
                                            {!readonly && (
                                                <td>
                                                    <>
                                                         <img
                                                             src="/assets/images/icons/edit.png"
                                                             onClick={() => openEditModal(raw)}
                                                             height="16px"
                                                             alt="Edit"
                                                             style={{ cursor: "pointer" }}
                                                             title="Edit"
                                                         />
                                                         &nbsp;&nbsp;&nbsp;
                                                         {activeTab === "1" && parseFloat(raw.remaining_stock || 0) > 0 && (
                                                             <>
                                                                 <i
                                                                     className="bi bi-arrow-left-right text-info"
                                                                     onClick={() => handleOpenTransferModal(raw)}
                                                                     style={{ cursor: "pointer", fontSize: "16px", verticalAlign: "middle" }}
                                                                     title="Transfer Packaging Material Quantity"
                                                                 ></i>
                                                                 &nbsp;&nbsp;&nbsp;
                                                             </>
                                                         )}
                                                         <img
                                                             src="/assets/images/icons/transfer-switch.png"
                                                             onClick={() => openAdjustModal(raw)}
                                                             height="16px"
                                                             alt="Adjust Stock"
                                                             style={{ cursor: "pointer" }}
                                                             title="Adjust Stock"
                                                         />
                                                         &nbsp;&nbsp;&nbsp;
                                                         <i
                                                             className="bi bi-file-earmark-text text-primary"
                                                             onClick={() => openReportModal(raw)}
                                                             style={{ cursor: "pointer", fontSize: "17px", verticalAlign: "middle" }}
                                                             title="Date-wise Stock Report"
                                                         ></i>
                                                         &nbsp;&nbsp;&nbsp;
                                                         <img
                                                             src="/assets/images/icons/delete.png"
                                                             onClick={() => handledeletemodel(raw.id)}
                                                             height="16px"
                                                             alt="Delete"
                                                             style={{ cursor: "pointer" }}
                                                             title="Delete"
                                                         />
                                                    </>
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                storageKey={activeTab === "1" ? "packaging_materials" : "raw_materials"}
                                onPageChange={handlePageChange}
                                entriesPerPage={entriesPerPage}
                                onEntriesPerPageChange={(val) => {
                                    const currentKey = activeTab === "1" ? "packaging_materials" : "raw_materials";
                                    setStoredEntriesPerPage(currentKey, val);
                                    setEntriesPerPage(val);
                                    setCurrentPage(1);
                                    fetchRawmaterials(1, searchText, activeTab, val);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {deletemodel && (
                <Deletemodel
                    setShowModal={showDeletemodel}
                    handleDelete={handleDelete}
                />
            )}

            {/* {showEditModal && ( */}
            <EditRawMaterials
                showModal={showEditModal}
                // setShowModal={() => setShowEditModal(false)}
                setShowModal={() => {
                    setShowEditModal(false);
                    setSelectedRaw(null);
                }}
                fetchRawmaterials={() => fetchRawmaterials(currentPage, searchText, activeTab)}
                selectedRawmaterial={selectedRaw}
                AddorEdit={addOrEdit}
                defaultType={activeTab === "1" ? "1" : "0"}
            />

            {showAdjustModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "550px" }}>
                        <div className="modal-content border-0 rounded-3 shadow">
                            <div className="modal-header px-4 py-3 bg-light d-flex justify-content-between align-items-center">
                                <div>
                                    <h5 className="modal-title font-bold text-dark mb-0" style={{ fontFamily: "poppins" }}>
                                        <i className="bi bi-sliders text-primary me-2"></i>
                                        Stock Adjustment: <span className="text-primary">{adjustRawMaterial?.title}</span>
                                    </h5>
                                    <small className="text-muted">
                                        Code: {adjustRawMaterial?.product_code || "N/A"} | Type: {adjustRawMaterial?.type == "1" ? "Packaging material" : adjustRawMaterial?.type == "2" ? "Liquid" : "Spices"} | Current Stock: <strong>{parseFloat(adjustRawMaterial?.remaining_stock || 0).toFixed(2)}</strong>
                                    </small>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => setShowAdjustModal(false)}
                                ></button>
                            </div>
                            <form onSubmit={handleAdjustSubmit}>
                                <div className="modal-body p-4" style={{ fontFamily: "poppins" }}>
                                    {/* Action Type */}
                                    <div className="mb-3">
                                        <label className="form-label font-semibold text-secondary">Adjustment Action <span className="text-danger">*</span></label>
                                        <div className="d-flex gap-4">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="rawAdjustAction"
                                                    id="rawActionAdd"
                                                    value="add"
                                                    checked={adjustFormData.adjustment_type === "add"}
                                                    onChange={(e) => handleAdjustFormChange("adjustment_type", e.target.value)}
                                                />
                                                <label className="form-check-label" htmlFor="rawActionAdd">
                                                    Add Stock (UP)
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="rawAdjustAction"
                                                    id="rawActionDeduct"
                                                    value="deduct"
                                                    checked={adjustFormData.adjustment_type === "deduct"}
                                                    onChange={(e) => handleAdjustFormChange("adjustment_type", e.target.value)}
                                                />
                                                <label className="form-check-label" htmlFor="rawActionDeduct">
                                                    Deduct Stock (DOWN)
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Date */}
                                    <div className="mb-3">
                                        <label className="form-label font-semibold text-secondary">Adjustment Date <span className="text-danger">*</span></label>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            value={adjustFormData.date}
                                            onChange={(e) => handleAdjustFormChange("date", e.target.value)}
                                            required
                                        />
                                    </div>

                                    {/* Quantity and Unit */}
                                    <div className="row g-2 mb-3">
                                        <div className="col-md-7">
                                            <label className="form-label font-semibold text-secondary">Quantity to Adjust <span className="text-danger">*</span></label>
                                            <input
                                                type="number"
                                                step="any"
                                                min="0.001"
                                                className="form-control form-control-sm"
                                                placeholder="Enter quantity"
                                                value={adjustFormData.qty}
                                                onChange={(e) => handleAdjustFormChange("qty", e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-5">
                                            <label className="form-label font-semibold text-secondary">Unit</label>
                                            <select
                                                className="form-select form-select-sm"
                                                value={adjustFormData.unit_id}
                                                onChange={(e) => handleAdjustFormChange("unit_id", e.target.value)}
                                            >
                                                <option value="">Select Unit</option>
                                                {(adjustRawMaterial?.type === "2" ? unitsList.filter(u => {
                                                    const title = (u.title || "").toLowerCase();
                                                    return title === "li" || title === "litre" || title === "litres" || title === "liter" || title === "liters";
                                                }) : adjustRawMaterial?.type === "1" ? [
                                                    unitsList.find(u => u.title?.toLowerCase() === "pcs") || { id: "pcs", title: "pcs" },
                                                    unitsList.find(u => u.title?.toLowerCase() === "kg") || { id: "kg", title: "kg" }
                                                ].filter(Boolean) : adjustRawMaterial?.type === "0" ? unitsList.filter(u => {
                                                    const title = (u.title || "").toLowerCase();
                                                    return title === "kg" || title === "kilogram" || title === "kilograms" || title === "g" || title === "gm" || title === "gram" || title === "grams";
                                                }) : unitsList).map((unit) => (
                                                    <option key={unit.id} value={unit.id}>
                                                        {unit.title}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Price and Total */}
                                    <div className="row g-2 mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label font-semibold text-secondary">Unit Price (INR)</label>
                                            <input
                                                type="number"
                                                step="any"
                                                min="0"
                                                className="form-control form-control-sm"
                                                placeholder="Unit price"
                                                value={adjustFormData.price_unit}
                                                onChange={(e) => handleAdjustFormChange("price_unit", e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label font-semibold text-secondary">Total Value (INR)</label>
                                            <input
                                                type="number"
                                                step="any"
                                                min="0"
                                                className="form-control form-control-sm"
                                                placeholder="Total price"
                                                value={adjustFormData.total_price}
                                                onChange={(e) => handleAdjustFormChange("total_price", e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    {/* Remarks */}
                                    <div className="mb-2">
                                        <label className="form-label font-semibold text-secondary">Remarks / Reason</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Optional remarks"
                                            value={adjustFormData.remarks}
                                            onChange={(e) => handleAdjustFormChange("remarks", e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="modal-footer border-t px-4 py-2 bg-light d-flex justify-content-end gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        onClick={() => setShowAdjustModal(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-sm px-3"
                                    >
                                        Save Adjustment
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Transfer Packaging Material Quantity Modal */}
            {showTransferModal && transferSource && (
                <div
                    className="modal fade show"
                    style={{
                        display: 'block',
                        backgroundColor: 'rgba(15, 23, 42, 0.65)',
                        backdropFilter: 'blur(4px)',
                        zIndex: 1065
                    }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '580px', width: '92%' }}>
                        <div
                            className="modal-content border-0 shadow-lg"
                            style={{
                                borderRadius: '16px',
                                overflow: 'hidden'
                            }}
                        >
                            {/* Modal Header */}
                            <div
                                className="modal-header px-4 py-3 d-flex align-items-center text-white"
                                style={{
                                    background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)',
                                    borderBottom: 'none'
                                }}
                            >
                                <div className="d-flex align-items-center gap-2.5">
                                    <div
                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                        style={{ width: '36px', height: '36px', backgroundColor: 'rgba(255,255,255,0.2)' }}
                                    >
                                        <i className="bi bi-arrow-left-right fs-5 text-white"></i>
                                    </div>
                                    <div>
                                        <h5 className="modal-title fw-bold m-0" style={{ fontSize: '18px' }}>
                                            Transfer Packaging Material Quantity
                                        </h5>
                                        <small style={{ opacity: 0.9, fontSize: '12px' }}>
                                            Transfer full or partial stock to another packaging material with matching unit
                                        </small>
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white ms-auto"
                                    onClick={() => {
                                        if (!isTransferring) {
                                            setShowTransferModal(false);
                                            setTransferSource(null);
                                        }
                                    }}
                                    disabled={isTransferring}
                                ></button>
                            </div>

                            {/* Modal Body */}
                            <div className="modal-body p-4" style={{ backgroundColor: '#f8fafc' }}>
                                {transferError && (
                                    <div className="alert alert-danger py-2 px-3 small d-flex align-items-center gap-2 mb-3 rounded-3">
                                        <i className="bi bi-exclamation-triangle-fill"></i>
                                        <span>{transferError}</span>
                                    </div>
                                )}

                                {/* Source Packaging Material Details Card */}
                                <div
                                    className="card border-0 mb-3 shadow-sm"
                                    style={{
                                        borderRadius: '12px',
                                        background: '#ffffff',
                                        border: '1px solid #e2e8f0'
                                    }}
                                >
                                    <div className="card-body p-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span className="badge px-2.5 py-1 text-uppercase fw-semibold" style={{ backgroundColor: '#e0f2fe', color: '#0369a1', fontSize: '11px', letterSpacing: '0.5px' }}>
                                                Source Material (Origin)
                                            </span>
                                            <span className="badge px-2.5 py-1 fw-bold" style={{ backgroundColor: '#f1f5f9', color: '#334155', fontSize: '12px' }}>
                                                Unit: {getUnitName(transferSource.unit_id)}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-baseline">
                                            <div>
                                                <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: '16px' }}>
                                                    {transferSource.title}
                                                </h6>
                                                <small className="text-muted">Code: {transferSource.product_code || 'N/A'}</small>
                                            </div>
                                            <div className="text-end">
                                                <small className="text-muted d-block" style={{ fontSize: '11px' }}>AVAILABLE STOCK</small>
                                                <span className="fw-bold fs-5 text-primary">
                                                    {parseFloat(transferSource.remaining_stock || 0).toFixed(3)} <span className="fs-6 fw-normal">{getUnitName(transferSource.unit_id)}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Destination Packaging Material Selection */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold small text-secondary d-flex justify-content-between align-items-center mb-1">
                                        <span>Target Packaging Material <span className="text-danger">*</span></span>
                                        <span className="text-muted" style={{ fontSize: '11px' }}>Matching unit: {getUnitName(transferSource.unit_id)}</span>
                                    </label>
                                    <Select
                                        options={transferTargetOptions}
                                        value={transferTarget}
                                        onChange={(option) => setTransferTarget(option)}
                                        placeholder="Search and select destination packaging material..."
                                        isClearable={false}
                                        isSearchable={true}
                                        styles={selectStyles}
                                        menuShouldScrollIntoView={false}
                                        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                        menuPosition="fixed"
                                        noOptionsMessage={() => `No other packaging materials found with unit '${getUnitName(transferSource.unit_id)}'`}
                                        isDisabled={isTransferring}
                                    />
                                    <small className="text-muted d-block mt-1" style={{ fontSize: '11.5px' }}>
                                        <i className="bi bi-info-circle me-1"></i>
                                        Only packaging materials with the matching unit ({getUnitName(transferSource.unit_id)}) are listed.
                                    </small>
                                </div>

                                {/* Transfer Date */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold small text-secondary d-flex justify-content-between align-items-center mb-1">
                                        <span>Transfer Date <span className="text-danger">*</span></span>
                                        <span className="text-muted" style={{ fontSize: '11px' }}>Date of material stock transfer</span>
                                    </label>
                                    <FormattedDateInput
                                        name="transferDate"
                                        value={transferDate}
                                        onChange={(e) => setTransferDate(e.target.value)}
                                        max={getFormattedCurrentDate2()}
                                        disabled={isTransferring}
                                        required={true}
                                    />
                                    <small className="text-muted d-block mt-1" style={{ fontSize: '11.5px' }}>
                                        <i className="bi bi-calendar-event me-1"></i>
                                        Default is set to current date ({moment(getFormattedCurrentDate2()).format('DD/MM/YYYY')}). Cannot be in the future.
                                    </small>
                                </div>

                                {/* Transfer Mode & Quantity */}
                                <div className="card border-0 mb-3 shadow-sm" style={{ borderRadius: '12px', background: '#ffffff', border: '1px solid #e2e8f0' }}>
                                    <div className="card-body p-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span className="fw-semibold small text-secondary">Transfer Mode & Quantity</span>
                                            <div className="btn-group btn-group-sm" role="group">
                                                <button
                                                    type="button"
                                                    className={`btn btn-sm px-3 ${transferType === 'partial' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                    onClick={() => {
                                                        setTransferType('partial');
                                                        const avl = parseFloat(transferSource?.remaining_stock || 0);
                                                        if (parseFloat(transferQty) >= avl) {
                                                            setTransferQty((avl / 2).toFixed(3));
                                                        }
                                                    }}
                                                    disabled={isTransferring}
                                                >
                                                    Partial
                                                </button>
                                                <button
                                                    type="button"
                                                    className={`btn btn-sm px-3 ${transferType === 'full' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                    onClick={() => {
                                                        setTransferType('full');
                                                        const avl = parseFloat(transferSource?.remaining_stock || 0);
                                                        setTransferQty(avl.toFixed(3));
                                                    }}
                                                    disabled={isTransferring}
                                                >
                                                    Full (100%)
                                                </button>
                                            </div>
                                        </div>

                                        <div className="mb-2">
                                            <div className="input-group">
                                                <span className="input-group-text bg-light text-secondary fw-semibold">
                                                    Qty to Transfer
                                                </span>
                                                <input
                                                    type="number"
                                                    step="0.001"
                                                    min="0.001"
                                                    max={parseFloat(transferSource.remaining_stock || 0)}
                                                    className="form-control fw-bold fs-6"
                                                    placeholder={`0.000 (Max: ${parseFloat(transferSource.remaining_stock || 0).toFixed(3)})`}
                                                    value={transferQty}
                                                    onWheel={(e) => e.currentTarget.blur()}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        setTransferQty(val);
                                                        const avl = parseFloat(transferSource?.remaining_stock || 0);
                                                        if (parseFloat(val) >= avl && avl > 0) {
                                                            setTransferType('full');
                                                        } else {
                                                            setTransferType('partial');
                                                        }
                                                    }}
                                                    disabled={isTransferring || transferType === 'full'}
                                                />
                                                <span className="input-group-text bg-light fw-bold text-muted">
                                                    {getUnitName(transferSource.unit_id)}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Quick Percent Presets */}
                                        <div className="d-flex align-items-center gap-1.5 flex-wrap pt-1">
                                            <small className="text-muted me-1" style={{ fontSize: '11px' }}>Quick:</small>
                                            {[25, 50, 75, 100].map(pct => (
                                                <button
                                                    key={pct}
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm py-0 px-2 rounded-pill me-1"
                                                    style={{ fontSize: '11px' }}
                                                    onClick={() => handlePresetPercent(pct)}
                                                    disabled={isTransferring}
                                                >
                                                    {pct}%
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                {/* Live Balance Summary */}
                                <div className="p-3 mb-3 rounded-3" style={{ backgroundColor: '#f1f5f9', border: '1px solid #cbd5e1' }}>
                                    <div className="row g-2 text-center">
                                        <div className="col-4">
                                            <small className="d-block text-muted text-uppercase" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>
                                                SOURCE REMAINING
                                            </small>
                                            <span className="fw-bold text-dark" style={{ fontSize: '15px' }}>
                                                {Math.max(0, (parseFloat(transferSource.remaining_stock || 0) - (parseFloat(transferQty) || 0))).toFixed(3)} {getUnitName(transferSource.unit_id)}
                                            </span>
                                        </div>
                                        <div className="col-4 border-start border-end border-slate-300">
                                            <small className="d-block text-muted text-uppercase" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>
                                                TRANSFERRING
                                            </small>
                                            <span className="fw-bold text-primary" style={{ fontSize: '15px' }}>
                                                {(parseFloat(transferQty) || 0).toFixed(3)} {getUnitName(transferSource.unit_id)}
                                            </span>
                                        </div>
                                        <div className="col-4">
                                            <small className="d-block text-muted text-uppercase" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>
                                                TARGET ADDED
                                            </small>
                                            <span className="fw-bold text-success" style={{ fontSize: '15px' }}>
                                                +{(parseFloat(transferQty) || 0).toFixed(3)} {getUnitName(transferSource.unit_id)}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Remarks / Transfer Note */}
                                <div className="mb-2">
                                    <label className="form-label fw-semibold small text-secondary mb-1">Remarks / Transfer Note</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={transferRemarks}
                                        onChange={(e) => setTransferRemarks(e.target.value)}
                                        placeholder="Optional transfer note..."
                                        disabled={isTransferring}
                                    />
                                </div>
                            </div>

                            {/* Modal Footer */}
                            <div className="modal-footer px-4 py-3 bg-light d-flex justify-content-between align-items-center" style={{ borderTop: '1px solid #e2e8f0' }}>
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary px-4 rounded-3"
                                    onClick={() => {
                                        setShowTransferModal(false);
                                        setTransferSource(null);
                                    }}
                                    disabled={isTransferring}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary px-4 rounded-3 d-flex align-items-center gap-2 shadow-sm"
                                    style={{ background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)', border: 'none' }}
                                    onClick={handleConfirmTransfer}
                                    disabled={isTransferring || !transferTarget || !(parseFloat(transferQty) > 0)}
                                >
                                    {isTransferring ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            <span>Transferring...</span>
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-arrow-left-right"></i>
                                            <span>Confirm Transfer</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Date-Wise Stock Report Modal */}
            {showReportModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-xl modal-dialog-centered" style={{ maxWidth: "95%", width: "1250px" }}>
                        <div className="modal-content border-0 rounded-3 shadow">
                            <div className="modal-header px-4 py-3 bg-light d-flex justify-content-between align-items-center">
                                <div>
                                    <h5 className="modal-title font-bold text-dark mb-0" style={{ fontFamily: "poppins" }}>
                                        <i className="bi bi-journal-text text-primary me-2"></i>
                                        Date-Wise Stock Report: <span className="text-primary">{reportRawMaterial?.title}</span>
                                    </h5>
                                    <small className="text-muted">
                                        Code: {reportRawMaterial?.product_code || "N/A"} | Type: {reportRawMaterial?.type == "1" ? "Packaging material" : reportRawMaterial?.type == "2" ? "Liquid" : "Spices"}
                                    </small>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => setShowReportModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body p-4" style={{ fontFamily: "poppins", maxHeight: "75vh", overflowY: "auto" }}>
                                {(() => {
                                    const totalAdded = allReportTransactions
                                        .filter(t => String(t.add_taken) === "1")
                                        .reduce((acc, t) => acc + convertTxQtyToBaseUnit(t), 0);

                                    const totalTaken = allReportTransactions
                                        .filter(t => String(t.add_taken) === "0")
                                        .reduce((acc, t) => acc + convertTxQtyToBaseUnit(t), 0);

                                    const totalTakenPcs = allReportTransactions
                                        .filter(t => String(t.add_taken) === "0" && (getUnitName(t.unit_id) || t.unit_id || "").toString().toLowerCase().includes("pc"))
                                        .reduce((acc, t) => acc + (parseFloat(t.qty) || 0), 0);

                                    const displayedTransactions = allReportTransactions.filter(item => {
                                        if (reportFilter === "1") return String(item.add_taken) === "1";
                                        if (reportFilter === "0") return String(item.add_taken) === "0";
                                        return true;
                                    });

                                    const unitStr = reportRawMaterial?.type == "2" ? "li" : getUnitName(reportRawMaterial?.unit_id);

                                    return (
                                        <>
                                            {/* Summary Cards */}
                                            <div className="row g-3 mb-4">
                                                <div className="col-md-4">
                                                    <div className="card h-100 border-0 shadow-sm bg-success bg-opacity-10 rounded-3 p-3 text-center d-flex flex-column justify-content-center">
                                                        <span className="text-uppercase text-muted fw-bold text-xs" style={{ fontSize: "11px" }}>Total Stock Added</span>
                                                        <h4 className="text-success fw-bold mb-0 mt-1 d-flex align-items-baseline justify-content-center gap-1">
                                                            <span>+ {totalAdded.toFixed(3)}</span>
                                                            <small style={{ fontSize: "14px" }}>{unitStr}</small>
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card h-100 border-0 shadow-sm bg-danger bg-opacity-10 rounded-3 p-3 text-center d-flex flex-column justify-content-center">
                                                        <span className="text-uppercase text-muted fw-bold text-xs" style={{ fontSize: "11px" }}>Total Stock Taken</span>
                                                        <h4 className="text-danger fw-bold mb-0 mt-1 d-flex align-items-baseline justify-content-center gap-1">
                                                            <span>- {totalTaken.toFixed(3)}</span>
                                                            <small style={{ fontSize: "14px" }}>{unitStr}</small>
                                                            {/* {totalTakenPcs > 0 && unitStr.toLowerCase() !== "pcs" && (
                                                                <small className="text-danger fw-semibold" style={{ fontSize: "13px" }}>
                                                                    ({totalTakenPcs.toFixed(0)} pcs)
                                                                </small>
                                                            )} */}
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card h-100 border-0 shadow-sm bg-primary bg-opacity-10 rounded-3 p-3 text-center d-flex flex-column justify-content-center">
                                                        <span className="text-uppercase text-muted fw-bold text-xs" style={{ fontSize: "11px" }}>Current Available Stock</span>
                                                        <h4 className="text-primary fw-bold mb-0 mt-1 d-flex align-items-baseline justify-content-center gap-1">
                                                            <span>{parseFloat(reportRawMaterial?.remaining_stock || 0).toFixed(3)}</span>
                                                            <small style={{ fontSize: "14px" }}>{unitStr}</small>
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Filter Tabs & Print Button */}
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="d-flex gap-2">
                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm ${reportFilter === "" ? "btn-primary shadow-none" : "btn-outline-primary shadow-none"}`}
                                                        style={{ borderRadius: "6px", boxShadow: "none", outline: "none" }}
                                                        onClick={() => setReportFilter("")}
                                                    >
                                                        All Transactions
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm ${reportFilter === "1" ? "btn-success shadow-none text-white" : "btn-outline-success shadow-none"}`}
                                                        style={{ borderRadius: "6px", boxShadow: "none", outline: "none" }}
                                                        onClick={() => setReportFilter("1")}
                                                    >
                                                        <i className="bi bi-arrow-down-left-circle me-1"></i> Stock Added (In)
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm ${reportFilter === "0" ? "btn-danger shadow-none text-white" : "btn-outline-danger shadow-none"}`}
                                                        style={{ borderRadius: "6px", boxShadow: "none", outline: "none" }}
                                                        onClick={() => setReportFilter("0")}
                                                    >
                                                        <i className="bi bi-arrow-up-right-circle me-1"></i> Stock Taken (Out)
                                                    </button>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-secondary shadow-none"
                                                    style={{ borderRadius: "6px", boxShadow: "none" }}
                                                    onClick={handlePrintReport}
                                                >
                                                    <i className="bi bi-printer me-1"></i> Print / Export
                                                </button>
                                            </div>

                                            {/* Printable Content Area */}
                                            <div ref={reportPrintRef}>
                                                {reportLoading ? (
                                                    <div className="text-center py-5">
                                                        <div className="spinner-border text-primary" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                        <p className="text-muted mt-2">Loading transactions...</p>
                                                    </div>
                                                ) : displayedTransactions.length === 0 ? (
                                                    <div className="alert alert-info text-center py-4 mb-0">
                                                        <i className="bi bi-info-circle fs-4 d-block mb-2"></i>
                                                        No transactions found for this filter view.
                                                    </div>
                                                ) : (
                                                    <div className="table-responsive">
                                                        <table className="table table-striped table-bordered table-sm align-middle text-xs mb-0">
                                                            <thead className="table-light">
                                                                <tr>
                                                                    <th>S.No</th>
                                                                    <th>Date & Time</th>
                                                                    <th>Type</th>
                                                                    <th>Quantity</th>
                                                                    <th>Unit Price</th>
                                                                    <th>Total Price</th>
                                                                    <th>Supplier / Remarks</th>
                                                                    <th>Remaining Balance</th>
                                                                    <th className="text-center no-print">Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {displayedTransactions.map((item, idx) => {
                                                                    const isAdded = String(item.add_taken) === "1";
                                                                    const formattedDate = item.date_time
                                                                        ? new Date(item.date_time).toLocaleString("en-GB", {
                                                                            day: "2-digit",
                                                                            month: "short",
                                                                            year: "numeric",
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                            hour12: true
                                                                        })
                                                                        : "-";
                                                                    const rowUnitStr = reportRawMaterial?.type == "2" ? "li" : getUnitName(item.unit_id || reportRawMaterial?.unit_id);
                                                                    return (
                                                                        <tr key={item.id || idx}>
                                                                            <td>{idx + 1}</td>
                                                                            <td className="fw-semibold">{formattedDate}</td>
                                                                            <td>
                                                                                {isAdded ? (
                                                                                    <span className="badge bg-success text-white px-2 py-1">
                                                                                        <i className="bi bi-plus-circle me-1"></i> Added
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className="badge bg-danger text-white px-2 py-1">
                                                                                        <i className="bi bi-dash-circle me-1"></i> Taken
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                            <td className={`fw-bold ${isAdded ? "text-success" : "text-danger"}`}>
                                                                                {isAdded ? `+ ${parseFloat(item.qty || 0).toFixed(3)}` : `- ${parseFloat(item.qty || 0).toFixed(3)}`} {rowUnitStr}
                                                                            </td>
                                                                            <td>
                                                                                {(() => {
                                                                                    const pUnit = parseFloat(item.price_unit || 0);
                                                                                    const qtyVal = parseFloat(item.qty || 0);
                                                                                    const pTotal = parseFloat(item.price || 0);
                                                                                    const unitPrice = pUnit > 0 ? pUnit : (qtyVal > 0 ? pTotal / qtyVal : 0);
                                                                                    return `₹${unitPrice.toFixed(2)}`;
                                                                                })()}
                                                                            </td>
                                                                            <td>₹{parseFloat(item.price || 0).toFixed(2)}</td>
                                                                            <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                                {isAdded ? (
                                                                                    item.supplier_name ? (
                                                                                        <span><strong>Supplier:</strong> {item.supplier_name}</span>
                                                                                    ) : item.remarks ? (
                                                                                        <span>{item.remarks}</span>
                                                                                    ) : (
                                                                                        <span className="text-muted">-</span>
                                                                                    )
                                                                                ) : (
                                                                                    (item.remarks || item.product_name || item.product_title || item.processing_qty) ? (
                                                                                        <span>
                                                                                            {item.remarks && <div>{item.remarks}</div>}
                                                                                            {(item.product_name || item.product_title || item.processing_qty) && (
                                                                                                <div className="mt-1" style={{ fontSize: "11px" }}>
                                                                                                    <span className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 py-1 px-2 fw-semibold">
                                                                                                        <i className="bi bi-box-seam me-1"></i>
                                                                                                        {item.product_name || item.product_title ? `Product: ${item.product_name || item.product_title}` : "Batch Output"}
                                                                                                        {item.processing_qty != null && item.processing_qty !== "" && !isNaN(parseFloat(item.processing_qty)) && (
                                                                                                            <span className="ms-1 fw-bold">
                                                                                                                ({parseFloat(item.processing_qty).toFixed(3)} {item.processing_unit || "kg"})
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </span>
                                                                                                </div>
                                                                                            )}
                                                                                            {item.supplier_name && (
                                                                                                <span className="text-muted d-block mt-1" style={{ fontSize: "11px" }}>
                                                                                                    (Batch from: {item.supplier_name})
                                                                                                </span>
                                                                                            )}
                                                                                        </span>
                                                                                    ) : item.supplier_name ? (
                                                                                        <span><strong>Supplier:</strong> {item.supplier_name}</span>
                                                                                    ) : (
                                                                                        <span className="text-muted">-</span>
                                                                                    )
                                                                                )}
                                                                            </td>
                                                                            <td className="fw-semibold">
                                                                                {item.remaining != null ? `${parseFloat(item.remaining).toFixed(3)} ${rowUnitStr}` : "-"}
                                                                            </td>
                                                                            <td className="text-center no-print">
                                                                                {isAdded ? (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-outline-danger btn-sm py-0 px-2 d-inline-flex align-items-center gap-1 shadow-none"
                                                                                        style={{ fontSize: "11px", height: "24px", borderRadius: "4px" }}
                                                                                        title="Revert / Remove Added Stock"
                                                                                        onClick={() => setRevertConfirmItem(item)}
                                                                                    >
                                                                                        <i className="bi bi-arrow-counterclockwise"></i> Revert
                                                                                    </button>
                                                                                ) : (
                                                                                    <span className="text-muted" style={{ fontSize: "11px" }}>-</span>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    );
                                })()}
                            </div>
                            <div className="modal-footer border-t px-4 py-2 bg-light text-end">
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-sm"
                                    onClick={() => setShowReportModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Revert Added Stock Confirmation Modal */}
            {revertConfirmItem && (
                <div
                    className="modal fade show d-block"
                    style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1065 }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "460px" }}>
                        <div className="modal-content border-0 rounded-3 shadow">
                            <div className="modal-header px-4 py-3 bg-danger text-white">
                                <h5 className="modal-title font-bold mb-0 fs-6">
                                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                    Confirm Stock Reversion
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    aria-label="Close"
                                    onClick={() => !revertLoading && setRevertConfirmItem(null)}
                                ></button>
                            </div>
                            <div className="modal-body p-4 text-center">
                                <i className="bi bi-arrow-counterclockwise text-danger display-4 d-block mb-3"></i>
                                <h6 className="fw-bold mb-2">Revert This Added Stock?</h6>
                                <p className="text-muted mb-3" style={{ fontSize: "13px" }}>
                                    Quantity: <strong>+ {parseFloat(revertConfirmItem.qty || 0).toFixed(3)} {reportRawMaterial?.type == "2" ? "li" : getUnitName(revertConfirmItem.unit_id || reportRawMaterial?.unit_id)}</strong>
                                    <br />
                                    {revertConfirmItem.supplier_name && <span>Supplier: <strong>{revertConfirmItem.supplier_name}</strong><br /></span>}
                                    {revertConfirmItem.batch_no && <span>Batch / Ref: <strong>{revertConfirmItem.batch_no}</strong><br /></span>}
                                </p>
                                <div className="alert alert-warning text-start mb-0 py-2 px-3" style={{ fontSize: "12px" }}>
                                    <i className="bi bi-info-circle me-1"></i>
                                    Reverting this stock will automatically remove it from <strong>inventory</strong>, <strong>trial balance (General Ledger)</strong>, and <strong>purchases & supplier credit</strong>.
                                </div>
                            </div>
                            <div className="modal-footer border-t px-4 py-2 bg-light d-flex justify-content-between">
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-sm"
                                    disabled={revertLoading}
                                    onClick={() => setRevertConfirmItem(null)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm d-flex align-items-center gap-1"
                                    disabled={revertLoading}
                                    onClick={handleConfirmRevert}
                                >
                                    {revertLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Reverting...
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-arrow-counterclockwise"></i>
                                            Yes, Revert Stock
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RawMaterials;
